import { useCallback, useEffect, useState } from 'react';
import { getDeletedMaterials, restoreMaterial } from '../../services/materialService';
import './MaterialTrash.css';

const formatDate = value => new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(new Date(value));
const remainingDays = value => Math.max(0, Math.ceil((new Date(value).getTime() - Date.now()) / 86400000));

const MaterialTrash = () => {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [restoringId, setRestoringId] = useState(null);

  const loadTrash = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setMaterials(await getDeletedMaterials());
    } catch {
      setError('Unable to load material Trash. Please try again.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadTrash(); }, [loadTrash]);

  const handleRestore = async material => {
    if (restoringId) return;
    setRestoringId(material._id);
    setError('');
    try {
      await restoreMaterial(material._id);
      setMaterials(current => current.filter(item => item._id !== material._id));
    } catch {
      setError(`Unable to restore "${material.materialName}". Please try again.`);
    } finally {
      setRestoringId(null);
    }
  };

  return (
    <section className="material-trash">
      <h1>Deleted materials</h1>
      <p>Materials remain recoverable for 7 days before automatic permanent deletion.</p>
      {error && <p role="alert" className="material-trash-error">{error}</p>}
      {loading && <p role="status">Loading Trash…</p>}
      {!loading && materials.length === 0 && <p>Trash is empty.</p>}
      <div className="material-trash-list">
        {materials.map(material => (
          <article key={material._id} className="material-trash-item">
            <h2>{material.materialName}</h2>
            <dl>
              <div><dt>Deleted:</dt><dd>{formatDate(material.deletedAt)}</dd></div>
              <div><dt>Permanently deleted:</dt><dd>{formatDate(material.purgeAfter)}</dd></div>
              <div><dt>Time remaining:</dt><dd>{remainingDays(material.purgeAfter)} days</dd></div>
            </dl>
            <button type="button" onClick={() => handleRestore(material)}
              disabled={!!restoringId}>
              {restoringId === material._id ? 'Restoring…' : 'Restore'}
            </button>
          </article>
        ))}
      </div>
    </section>
  );
};

export default MaterialTrash;
